// File: assets/order-track.js
// Description: This script handles the order tracking functionality for a web page. It includes input validation, form submission, and displaying tracking information.

document.addEventListener("DOMContentLoaded", function () {
    var inputOrder = document.getElementById("inputOrder");
    var trackingForm = document.getElementById("trackingForm");
    var loader = document.querySelector(".loader");
    var trackingResult = document.getElementById("trackingResult");
    var mainTrackOrder = document.querySelector(".MainTrackOrder");
    var trackingActivities = document.getElementById("tracking_activites");
    var steps = document.querySelectorAll(".step");
    var accordionHeaders = document.querySelectorAll(".accordion-header");

    function show(el, type) {
        if (el) el.style.display = type || "block";
    }

    function hide(el) {
        if (el) el.style.display = "none";
    }

    inputOrder.addEventListener("input", function () {
        this.value = this.value.toUpperCase().replace(/[^a-zA-Z0-9]/g, '');
    });

    for (var i = 0; i < accordionHeaders.length; i++) {
        accordionHeaders[i].addEventListener("click", function () {
            var content = this.nextElementSibling;
            var isActive = this.classList.toggle("active");
            content.style.display = isActive ? "block" : "none";

            for (var j = 0; j < accordionHeaders.length; j++) {
                if (accordionHeaders[j] !== this) {
                    accordionHeaders[j].classList.remove("active");
                    accordionHeaders[j].nextElementSibling.style.display = "none";
                }
            }
        });
    }

    trackingForm.addEventListener("submit", function (event) {
        event.preventDefault();

        show(loader);
        hide(trackingResult);
        hide(mainTrackOrder);
        hide(trackingActivities);

        for (var i = 0; i < accordionHeaders.length; i++) {
            if (accordionHeaders[i].classList.contains("active")) {
                accordionHeaders[i].click();
                var history = accordionHeaders[i].nextElementSibling.querySelector(".trackinghistory");
                if (history) history.innerHTML = "";
            }
        }

        for (var i = 0; i < steps.length; i++) {
            steps[i].classList.remove("completed");
        }

        var awbValue = inputOrder.value.trim();
        if (!awbValue) {
            hide(loader);
            show(trackingResult);
            trackingResult.textContent = "Please enter a valid tracking ID or Order ID";
            return;
        }

        fetch("https://apis.novology.com/novo-prod/Tracking/orderTrackingBlueDart.php?awb=" + awbValue)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                hide(loader);
                inputOrder.value = "";

                var shipment = data && data.tracking_results && data.tracking_results.ShipmentData &&
                               data.tracking_results.ShipmentData.Shipment &&
                               data.tracking_results.ShipmentData.Shipment[0];

                if (data.orderId && !shipment) {
                    show(trackingResult);
                    trackingResult.textContent = "Your order is confirmed, please check after some time.";
                    return;
                }

                if (!shipment) {
                    show(trackingResult);
                    trackingResult.textContent = "This Order is either cancelled or invalid.";
                    return;
                }

                document.getElementById("query-trackingID").textContent = awbValue;
                document.getElementById("sr_AWB").textContent = shipment.WaybillNo;
                document.getElementById("sr-current_status").textContent = shipment.Status.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
                    return c.toUpperCase();
                });
                document.getElementById("sr-courier_name").textContent = shipment.Service;

                var detailLink = document.getElementById("detailTrackingLink");
                detailLink.setAttribute("href", "https://www.bluedart.com/web/guest/trackdartresultthirdparty?trackFor=0&&trackNo=" + shipment.WaybillNo);
                detailLink.setAttribute("target", "_blank");

                var scans = shipment.Scans || [];

                if (scans.length > 0) {
                    for (var i = 0; i < scans.length; i++) {
                        var scan = scans[i].ScanDetail.Scan;

                        if (scan.indexOf("Online shipment booked") !== -1) steps[0].classList.add("completed");
                        if (scan.indexOf("PICKUP EMPLOYEE IS OUT TO P/U SHIPMENT") !== -1 || scan.indexOf("SHIPMENT PICKED UP") !== -1) steps[1].classList.add("completed");
                        if (scan.indexOf("SHIPMENT OUT FOR DELIVERY") !== -1) steps[2].classList.add("completed");
                        if (scan.indexOf("SHIPMENT DELIVERED") !== -1) steps[4].classList.add("completed");

                        if (scan.indexOf("RTO") !== -1) {
                            steps[3].classList.add("completed");
                            steps[3].style.display = "flex";
                            steps[4].style.display = "none";
                        }
                    }
                }

                show(mainTrackOrder, "flex");
                show(trackingActivities, "flex");
            })
            .catch(function (error) {
                console.error(error);
                hide(loader);
                show(trackingResult);
                trackingResult.textContent = "There was an error retrieving the shipment details.";
            });
    });
});
